import { listSentence } from '@/lib/formatters'
import type { EmailRecipients } from '@/models/fillApplication'

interface EmailRecipientsLineProps {
  recipients: EmailRecipients
  /** Website applications get "Your prices are in" emails; the others don't. */
  priceEmails: boolean
}

export function EmailRecipientsLine({ recipients, priceEmails }: EmailRecipientsLineProps) {
  const owner = recipients.priceAndLink
  if (!owner) return null
  // The server lists every business owner, the owner included.
  const others = recipients.quoteReady
    .filter((person) => person.id !== owner.id)
    .map((person) => person.name || person.email)

  return (
    <p className="text-ink-500 text-sm">
      {priceEmails ? 'Price emails and the sign-in link go to' : 'The sign-in link goes to'} {owner.email}.
      {others.length > 0 && <> Quote-ready emails also go to {listSentence(others)}.</>}
    </p>
  )
}
